import { render, staticRenderFns } from "./LayoutSidenav.1.vue?vue&type=template&id=7453ef17&"
import script from "./LayoutSidenav.1.vue?vue&type=script&lang=js&"
export * from "./LayoutSidenav.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports